var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.photosLocal),function(photo,photoIndex){return _c('div',{key:photoIndex},[_c('img',{attrs:{"src":photo.webviewPath,"alt":""}})])}),_c('bottom-bar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }